export default __webpack_public_path__ + "static/media/firedUserBG.93547b1c.png";